// Frontend runtime config. API is same-origin (Vite proxies /api and /image to
// the backend in dev; Caddy does the same in prod).
export default {
  languages: ["en", "de"],
  defaultLanguage: "en",
  imageBase: "/image",
};
